import { Minus, Plus } from 'lucide-react'
import { MAX_COLUMNS, MIN_COLUMNS } from '@/features/discovery/use-browse-columns'

interface BrowseColumnsSliderProps {
  columns: number
  onChange: (next: number) => void
}

/**
 * Inspiration-mode density slider — "less or more" tiles per row. The underlying mechanic is
 * a column count, but the UI abstracts that away: just minus on the left, plus on the right,
 * a slider track between. Users drag toward more (denser, smaller cards) or less (fewer,
 * bigger cards) without thinking about exact columns.
 *
 * <p>Plain {@code <input type="range">} styled with Tailwind. Upgrade to the shadcn slider
 * primitive if more sliders show up elsewhere.
 */
export const BrowseColumnsSlider = ({ columns, onChange }: BrowseColumnsSliderProps) => (
  <div
    role="group"
    aria-label="Tile density"
    className="inline-flex items-center gap-1.5 text-muted-foreground"
  >
    <Minus className="h-3.5 w-3.5" aria-hidden />
    <input
      type="range"
      min={MIN_COLUMNS}
      max={MAX_COLUMNS}
      step={1}
      value={columns}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label="Tile density"
      className="h-1.5 w-28 cursor-pointer appearance-none rounded-full bg-muted accent-primary"
    />
    <Plus className="h-3.5 w-3.5" aria-hidden />
  </div>
)
